import { REPORT_OBJECT_FIRM } from '@/constants';
import { SendObject } from '@/enums';

/**
 * @description 发布对象
 */
export const reportObject = (reportType: number) => {
  return REPORT_OBJECT_FIRM.some(report => report.reportType === reportType) ? SendObject.OBJECT_FIRM : SendObject.OBJECT_ASSOCIATION;
};
